import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { Title } from "../../../../../../stories/Title/Title";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import {
  StyledDatagrid,
  useDataGridStyles,
} from "../../../../../../styles/DatagridStyles";
import { TableHeaderProps } from "../../../../../../utils/types";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import { Keys } from "../../../../../../utils/Enum.keys";
import Compare from "../../../../../../images/Compare.svg";
import {
  getModifiedScrollHeight,
  handleMUISelectEvent,
  toInputStandardDate,
  toIsoDate,
} from "../../../../../../utils/UtilFunctions";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import Download from "../../../../../../images/DownloadImage.svg";
import Negotiate from "../../../../../../images/Negotiate.svg";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import Yes from "../../../../../../images/ApprovedStatus.svg";
import No from "../../../../../../images/RejectedStatus.svg";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  AtsRfqTrnSupplyEdge,
  AtsRfqTrnSupplyOrderField,
  GetRfqTrnSupplyResult,
  GetRfqTrnSupplyVar,
  RfqListInitializationType,
  RfqSupplyQueryType,
} from "./queries/types";
import { useLazyQuery } from "@apollo/client";
import { GetRfqTrnSupply } from "./queries/queries";

import { AppContext } from "../../../../../../context/context";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { emptyFunc, FETCH_MORE_DATA } from "../../../../../../utils/constants";
import { RfqQueryType } from "../queries/types";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import { formDates } from "../../material/ApprovedList";
import LoggedEmployee from "../../../../../../customComponents/LoggedEmployee";
import LoadingModal from "../../../../../pages/LoadingModal";
import ItemSelect from "../../../../../../customComponents/ItemSelect";
import { MrfQueryType } from "../../material/queries/types";
import { payloadTypes } from "../../../../../../context/reducer";
import Navbar from "../../../../../common/layout/Navbar";
import { LicenseTypes } from "../../../../../../utils/Enum.types";
import useLabels from "../../../../../../customHooks/useLabels";

export const enum NegotiationPage {
  GENERAL = "General",
  PREVIEW = "Preview",
  VIEW = "View",
}

export const rfqListInitialization: RfqListInitializationType = {
  id: 1,
  item_desc: "",
  required_quantity: 0,
  terms: "",
  payment_terms: "",
  vendor_sl: 1,
  quoted_qty: "",
  rate: 0,
  any_other_charges: 0,
  tax_perc: 0,
  total_amount: 0,
  others: 0,
  net_quoted: 0,
  remarks: "",
  upload_product_details: "",
  place_order: false,
  verbal_final_rate: 0,
  taxes: 0,
  order_qty: 0,
  negotiation_by: "",
  verbal_final_amount: 0,
};

interface Props {
  pageType: NegotiationPage;
}
const Negotiation = ({ pageType }: Props) => {
  const navigate = useNavigate();
  const { headerStyles } = useDataGridStyles();
  const { customer_id, company_id, rfq_id } = useUrlParams();
  const { Purchase } = useAssetTableJson();
 
  const { state, dispatch } = useContext(AppContext);

  const [remark, setRemark] = useState("");
  const [rfqComparisionDate, setRfqComparisionDate] = useState("");

  const [rfqComparisionInspectedBy, setRfqComparisionInspectedBy] =
    useState("");

  const [rfqNo, setRfqNo] = useState("");
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [categories, setCategories] = useState<AtsRfqTrnSupplyEdge[]>([]);
  const [orderStatus, setOrderStatus] = useState(true);

  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const [getRfqTrnSupply, { data, loading, fetchMore }] = useLazyQuery<
    GetRfqTrnSupplyResult,
    GetRfqTrnSupplyVar
  >(GetRfqTrnSupply);

  const dynamicHeaders: TableHeaderProps[] =
    Purchase.Quotation.Comparision.Negotiation.filter((header) => {
      if (
        pageType === NegotiationPage.PREVIEW &&
        header.field === "negotiation"
      ) {
        return false;
      }
      return true;
    }).map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      // colSpan:header.colSpan,
      renderCell: (params) => {
        if (header.field === "negotiation") {
          return (
            <>
              <button
                className="negotiation__tableblock--negotiate"
                onClick={() => {
                  navigate(
                    `/${customer_id}/company/${company_id}/purchase/mqcomparision/${rfq_id}/${params.row.rfqTrnSupplyId}/negotiation/filldetails`
                  );
                }}
              >
                Negotiate <img src={Negotiate} alt="" />
              </button>
              {/* <button className="negotiation__tableblock--update">
                Update <img src={Update} alt="" />
              </button> */}
            </>
          );
        } else if (header.field === "upload_product_details") {
          return (
            <div className="quotation-form__block--file">
              {/* <img src={getFileIcon(params.row.upload_product_details)} alt="" /> */}
              {params.row.upload_product_details}
              <img src={Download} alt="" />
            </div>
          );
        } else if (header.field === "place_order") {
          return (
            <div className="negotiation__tableblock--place-order">
              {params.row.place_order ? (
                <>
                  <img src={Yes} alt="" /> Yes
                </>
              ) : (
                <>
                  <img src={No} alt="" /> No
                </>
              )}
            </div>
          );
        }
        return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MATERIAL_REQUEST_NEGOTIATION
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.MATERIAL_REQUEST_NEGOTIATION,
      JSON.stringify(newModel)
    );
  };

  const rowsData = useMemo(() => {
    return categories.map(({ node }, index) => {
      const totalAmount =
        Number(node.quotedQty) *
        Number(node.quotedRate) *
        (Number(node.quotedTax) / 100);
      return {
        rfqTrnSupplyId: node.id,
        id: index + 1,
        item_desc: node.rfqTrn.udfItemDesc,
        required_quantity: node.rfqTrn.trnQty,
        terms: node.rfqTrn.itemTerms,
        payment_terms: node.rfqTrn.itemPaymentTerms,

        vendor_sl: node.slNo,
        quoted_qty: node.quotedQty,
        rate: node.quotedRate,
        any_other_charges: node.quotedAnyChanges,
        tax_perc: node.quotedTax,
        total_amount: totalAmount,
        others: node.quotedOther,
        net_quoted: node.quotedValue,
        remarks: node.quotedRemarks,
        // upload_product_details:node.itemDescChanged

        place_order: node.negoStatus,
        verbal_final_rate: node.negoRate,
        taxes: node.negoTax,
        order_qty: node.negoQty,
        verbal_final_amount: node.negoValue,
        // negotiation_by:
      };
    });
  }, [categories]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;
              const newEdges = fetchMoreResult.GetRfqTrnSupply.edges;
              const pageInfo = fetchMoreResult.GetRfqTrnSupply.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetRfqTrnSupply.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetRfqTrnSupply: {
                  edges: [...categories, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetRfqTrnSupply.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rowsData.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rowsData]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetRfqTrnSupply.edges;
      if (newData.length) {
        setRfqNo(newData[0].node.rfq.rfqNo);
      }
      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = categories.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setCategories(updatedNewData);
      } else {
        setCategories(newData);
      }
      setEndCursor(data.GetRfqTrnSupply.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    if (todaysDateData && serverDate) {
      const getMonth = new Date(serverDate).getMonth();
      const getYear = new Date(serverDate).getFullYear();

      const firstDay = new Date(getYear, getMonth, 1); // First day of the month
      const lastDay = new Date(getYear, getMonth + 1, 0);

      setDates({
        endDate: lastDay.toString(),
        startDate: firstDay.toString(),
      });
    }
  }, [todaysDateData, serverDate]);

  useEffect(() => {
    if (
  
      customer_id &&
      state.ActiveFinYr &&
      dates.endDate &&
      dates.startDate &&
      rfq_id
    ) {
      getRfqTrnSupply({
        variables: {
          
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          rfqId: rfq_id,
          queryType: RfqSupplyQueryType.ALL,
          end_date: toIsoDate(dates.endDate),
          start_date: toIsoDate(dates.startDate),
          after: null,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsRfqTrnSupplyOrderField.SL_NO,
          },
          name: orderStatus,
        },
      });
    }
  }, [
    getRfqTrnSupply,
    customer_id,
    state.ActiveFinYr,
    dates.endDate,
    dates.startDate,
    rfq_id,
    orderStatus,
  ]);
  const { itemLabel } = useLabels();
  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>Material Quotation Comparision (Negotiation)</Title>
      <div className="negotiation">
        <div className="negotiation__header row g-0">
          <div className="col">
            <div className="label-grid">
              <Label>RFQ no.</Label>
              <Input value={rfqNo ? rfqNo : 0} disabled />
            </div>
          </div>
          <div className="col"></div>
          <div className="col-4 mq-comparision__filters--flex">
            <TextField
              label="Start Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className="mq-comparision__filters--date"
              type="date"
              value={toInputStandardDate(dates.startDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  startDate: e.target.value,
                });
              }}
            />
            <img
              src={Compare}
              alt=""
              className="mq-comparision__filters--compare"
            />
            <TextField
              label="End Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className="mq-comparision__filters--date"
              type="date"
              value={toInputStandardDate(dates.endDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  endDate: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <div className="negotiation__filters row g-0">
          <div className="col-2">
            <ItemSelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_ITEM_ID,
                    payload: {
                      itmId: newValue.value,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_ITEM_ID,
                    payload: {
                      itmId: 0,
                    },
                  });
                }
              }}
              onKeyDown={emptyFunc}
              value={state.itmId}
              label={`Filter ${itemLabel}`}
              placeholder=""
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              options={["FINALIZED", "NOT FINALIZED"]}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              openOnFocus
              forcePopupIcon
              freeSolo
              value={orderStatus ? "FINALIZED" : "NOT FINALIZED"}
              onChange={(event, newValue) => {
                setOrderStatus(newValue === "FINALIZED" ? true : false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Order Placed"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
        </div>
        <div
          className={`negotiation__tableblock${
            pageType === NegotiationPage.GENERAL ? "" : "--preview"
          }`}
        >
          <StyledDatagrid
            columns={columns}
            rows={rowsData}
            rowHeight={TABLE_ROW_HEIGHT}
            sx={{
              ...headerStyles,
            }}
            // columnGroupingModel={columnGroupingModel}
            unstable_rowSpanning
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            disableRowSelectionOnClick
            hideFooter
            initialState={{
              pinnedColumns: {
                left: [
                  "id",
                  "item_desc",
                  "required_quantity",
                  "terms",
                  "payment_terms",
                ],
                right: [
                  "place_order",
                  "verbal_final_rate",
                  "taxes",
                  "order_qty",
                  "verbal_final_amount",
                  "negotiation_by",
                  "negotiation",
                ],
              },
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
          />
        </div>
        {pageType === NegotiationPage.PREVIEW ? (
          <div className="negotiation__details row g-0">
            <div className="col">
              <div className="negotiation__details--grid">
                <Label>RFQ Comparision Date</Label>
                <Input
                  type="date"
                  onChange={(e) => {
                    setRfqComparisionDate(e.target.value);
                  }}
                />
                <Label>RFQ Comparision Inspected By</Label>
                <Input
                  type="text"
                  onChange={(e) => {
                    setRfqComparisionInspectedBy(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col">
              <div className="label-grid">
                <Label>Remarks</Label>
                <TextArea
                  rows={2}
                  onChange={(e) => {
                    setRemark(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        ) : pageType === NegotiationPage.VIEW ? (
          <div className="negotiation__details row g-0">
            <div className="col">
              <div className="negotiation__details--grid">
                <Label>RFQ Comparision Date</Label>
                <Input
                  type="date"
                  value={toInputStandardDate(serverDate)}
                  onChange={(e) => {
                    setRfqComparisionDate(e.target.value);
                  }}
                />
                <Label>RFQ Comparision Inspected By</Label>
                <LoggedEmployee />
              </div>
            </div>
            <div className="col">
              <div className="label-grid">
                <Label>Remarks</Label>
                <TextArea
                  rows={2}
                  onChange={(e) => {
                    setRemark(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        ) : null}

        {pageType === NegotiationPage.PREVIEW ? (
          <Button mode="save" />
        ) : pageType === NegotiationPage.VIEW ? (
          <Button mode="edit" />
        ) : (
          <Button
            mode="finalize"
            onClick={() =>
              navigate(
                `/${customer_id}/company/${company_id}/purchase/mqcomparision/negotiation/preview`
              )
            }
          />
        )}

        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
      <LoadingModal flag={loading} />
    </>
  );
};

export default Negotiation;
